import styled from "@emotion/styled";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import type { ReactNode } from "react";

import If from "~/core/ui/If";

import type { IconProp } from "@fortawesome/fontawesome-svg-core";

type ItemIconProps = {
  faIcon?: IconProp;
  customIcon?: ReactNode;
};

const StyledIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  color: currentColor;
`;

export default function ItemIcon({ faIcon, customIcon }: ItemIconProps) {
  if (!faIcon && !customIcon) return null;

  return (
    <StyledIcon className="fade-in">
      <If condition={!!faIcon} fallback={customIcon}>
        <FontAwesomeIcon icon={faIcon as IconProp} />
      </If>
    </StyledIcon>
  );
}
